<!-- user-center-order-submit-detail -->

<template>
  <div class="enter-order-page">
    <div class="content-box">
      <!-- 收货地址 -->
      <div v-if="orderInfo.isAddress" class="box1 budo-box">
        <div v-if="orderInfo.address" class="user-box">
          <div class="flex-row row-between col-end">
            <div>
              <span style="font-size: 14px">收货人：</span>
              <span>{{ orderInfo.username }}</span>
            </div>
            <div>{{ orderInfo.contactMobile }}</div>
          </div>
          <div class="flex-row row-between col-center mt12">
            <div>
              <span style="font-size: 14px">收货地址：</span>
              <span v-if="orderInfo.address"> {{ orderInfo.address }}</span>
            </div>
          </div>
        </div>
        <div v-else class="user-box">
          <div class="flex-row row-between col-end">
            <div>
              <span style="font-size: 14px"></span>
              <span></span>
            </div>
            <div></div>
          </div>
          <div
            class="flex-row row-between col-center mt12"
            @click="goAddress()"
          >
            <div>
              <span style="font-size: 14px"
                >还没有设置默认收货地址？<span style="color: #f00"
                  >立即设置</span
                ></span
              >
            </div>
            <van-icon
              class="ml8"
              name="arrow"
              style="font-size: 18px; color: #727272"
            />
          </div>
        </div>
      </div>

      <!-- 商品信息 -->
      <div class="box1">
        <div class="budo-box">
          <div v-for="goods of orderInfo.goods" :key="goods.goodsName">
            <van-card
              class="budo-order-goods"
              :desc="Array.isArray(goods.spec) ? goods.spec.join(',') : ''"
              :num="goods.goodsQuantity"
              :thumb="
                goods.goodsHeadImage ||
                'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png'
              "
            >
              <template #title>
                <span style="font-weight: 800" @click="order2detail(order)">{{
                  goods.goodsName
                }}</span>
              </template>

              <template #price>
                <div
                  v-if="
                    orderInfo.orderType !== 'movie' &&
                    orderInfo.cardQuantity > 0
                  "
                ></div>
                <div v-else>
                  <img
                    class="price-icon"
                    src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
                    style="width: 18px; height: 18px"
                  /><span style="font-size: 14px">{{
                    goods.goodsPrice | money
                  }}</span>
                </div>
              </template>
            </van-card>
          </div>
        </div>

        <div
          class="info"
          v-if="
            !(orderInfo.orderType !== 'movie' && orderInfo.cardQuantity > 0)
          "
        >
          <div class="flex-row row-between">
            <div>商品金额：</div>
            <span style="color: #ff7800">{{
              (orderInfo.fee - expressFee) | money
            }}</span>
          </div>
          <div v-if="expressFee > 0" class="flex-row mt10 row-between">
            <div>运费：</div>
            <div>{{ expressFee === 0 ? "包邮" : expressFee | money }}</div>
          </div>
          <div class="flex-row mt10 row-between">
            <div>实付：</div>
            <span style="color: #ff7800">{{ orderInfo.fee | money }}</span>
          </div>
        </div>

        <!-- extInfo 和 备注 -->
        <div
          v-if="
            (orderInfo.extInfo &&
              orderInfo.extInfo !== '' &&
              orderInfo.length > 0) ||
            (orderInfo.expressInfo && orderInfo.expressInfo.img)
          "
          class="info budo-ext-express"
        >
          <div
            v-if="
              orderInfo.extInfo &&
              orderInfo.extInfo !== '' &&
              orderInfo.length > 0
            "
          >
            <div
              v-for="item in orderInfo.extInfo"
              :key="item.key"
              class="flex-row mt22 row-between"
              style="border-bottom: dashed #eee 1px; align-items: center"
            >
              <div v-if="item.key">{{ item.key }}:</div>
              <span
                v-if="item.value"
                style="text-align: right"
                v-html="item.value"
              ></span>
            </div>
          </div>

          <div v-if="orderInfo.expressInfo && orderInfo.expressInfo.img">
            <div style="width: 100%">
              <van-cell-group :border="false" inset>
                <van-cell
                  v-for="(img, index) of imgs"
                  :key="index"
                  :border="false"
                  :title="'发货信息' + (index + 1)"
                  value="查看图片"
                  @click="onLogistcsImg(img)"
                />
              </van-cell-group>
            </div>
          </div>

          <div v-if="orderDescription" class="flex-row mt22">
            <div>备注：</div>
            <input
              v-model="orderDescription"
              class="remark-input"
              placeholder="订单备注 ~"
              type="text"
              readonly
            />
          </div>
        </div>

        <!-- 身份证信息 -->
        <div
          v-if="orderInfo.identityInfo && orderInfo.identityInfo.length > 0"
          class="info budo-sfz-106"
        >
          <div
            v-for="item in orderInfo.identityInfo"
            :key="item.cardId"
            class="identity-list"
          >
            <div>
              {{ item.name }}, {{ item.mobile }}
              <div style="font-size: 14px; margin-top: 5px">
                身份证
                {{ item.cardId.substr(0, 4) }} ***********
                {{ item.cardId.substr(item.cardId.length - 3) }}
              </div>
            </div>
          </div>
        </div>

        <div class="info">
          <div class="flex-row" style="align-items: center">
            <div style="margin-right: 5px">订单编号</div>
            <div>{{ orderInfo.orderId }}</div>
          </div>
          <div class="flex-row" style="margin-top: 5px; align-items: center">
            <div style="margin-right: 5px">下单时间</div>
            <div>{{ orderInfo.createTime }}</div>
          </div>
          <div class="flex-row" style="margin-top: 5px; align-items: center">
            <div style="margin-right: 5px">订单状态</div>
            <div>{{ orderInfo.statusOrder | orderStatusFilter }}</div>
          </div>
          <div class="flex-row" style="margin-top: 5px; align-items: center">
            <div style="margin-right: 5px">支付状态</div>
            <div>{{ orderInfo.statusPay | payStatusFilter }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 查看券码 -->
    <van-cell style="margin-top: 20px">
      <div style="text-align: right">
        <van-button
          v-if="orderInfo.codes && orderInfo.codes.length > 0"
          plain
          round
          size="small"
          style="margin-left: 8px"
          type="danger"
          @click="showCardInfo(orderInfo.orderId)"
          >查看券码</van-button
        >

        <van-button
          v-if="orderInfo.codes && orderInfo.codes.length > 0"
          plain
          round
          size="small"
          style="margin-left: 8px"
          @click="showHowToUse(orderInfo.codes[0].goodsId)"
          >使用方法</van-button
        >

        <!-- 支付状态为已支付 且 订单状态不为已申请取消 才会展示这个按钮 -->
        <van-button
          v-if="
            orderInfo.statusPay == 1 &&
            orderInfo.statusOrder != 1 &&
            wxUser.openid &&
            wxUser.openid.indexOf('_-^-_') > 0
          "
          style="margin-left: 5px"
          round
          size="small"
          @click="cancelOrder(orderInfo.orderId)"
          >申请退款</van-button
        >

        <van-button style="margin-left: 5px" round size="small" @click="go_kefu"
          >联系客服</van-button
        >
      </div>
    </van-cell>

    <!-- 展示券码的弹窗 -->
    <OrderCodeDialog ref="OrderCodeDialog" />

    <!-- 展示如何使用 -->
    <HowToUseDialog ref="HowToUseDialog" />

    <!-- 底部支付工具条 不能支付就不展示 -->
    <div
      v-if="!is_pay && this.payEnabled"
      class="box4 flex-row col-center row-end"
    >
      <div class="flex-row">
        <div></div>
        <div
          class="flex-row col-center"
          v-if="
            !(orderInfo.orderType !== 'movie' && orderInfo.cardQuantity > 0)
          "
        >
          <span style="font-size: 15px"
            >合计 : <span style="color: #ff7800; font-size: 12px"></span>
            <span style="color: #ff7800">{{
              orderInfo.fee | money
            }}</span></span
          >
        </div>
        <div
          class="text-center ml8"
          style="
            height: 50px;
            width: 115px;
            background-color: #fc3f3f;
            color: white;
            line-height: 50px;
          "
          @click="paySetup"
        >
          支付订单
        </div>
      </div>
    </div>

    <van-popup
      v-model="showInputPassword"
      :style="{ height: '400px', background: '#f5f5f5' }"
      position="bottom"
    >
      <van-password-input
        :gutter="10"
        :value="payPassword"
        info="请输入卡券支付密码(密码为 6 位数字)"
        style="margin-top: 10px"
        @focus="isVisibKeyboard = true"
      />
      <van-number-keyboard
        v-model="payPassword"
        :maxlength="6"
        :show="isVisibKeyboard"
        @input="passwordInput"
      />
    </van-popup>
  </div>
</template>

<script>
import { wx_cancel_order } from "@/api/goods-api";
import { wx_get_goods_order_detail, mall_orders_repay } from "@/api/goods-api";
import { wx_sdk_wx_pay } from "@/util/wxSdk";
import {
  GOODS_CATE_INFO,
  GOODS_TYPE_GENERAL_GOODS,
  ORDER_TYPE_HEALTH,
  ORDER_TYPE_TRAVEL,
} from "@/api/constant";
import { Dialog, ImagePreview, Toast } from "vant";
import OrderCodeDialog from "@/components/common/OrderCodeDialog";
import HowToUseDialog from "@/components/common/HowToUseDialog";
import { mall_wx_get_user_info } from "@/api/login";
import request from "@/util/axios";
import { $wx_kefu_rc } from "@/util/wxSdk";

export default {
  name: "index",

  components: {
    OrderCodeDialog,
    HowToUseDialog,
  },

  data() {
    return {
      defaultAddress: this.$store.getters.address,
      goodsTotal: this.$store.getters.orderInfo.total,
      goodsInfo: {},
      expressFee: 0,
      orderFee: 0,
      goodsCount: 0,
      visiblePaySetup: false,
      orderDescription: "",
      is_pay: 1,
      payEnabled: false,
      errorMsg: "",
      goodsType: 0,
      orderId: "",
      orderInfo: {},
      payPassword: "",
      isVisibKeyboard: false,
      showInputPassword: false,
      extInfo: {},
      imgs: [],

      wxUser: {},
    };
  },

  created() {
    this.orderId = this.$route.query.orderId;
    this.load_order_info();
  },

  mounted() {
    this.is_pay = parseInt(this.$route.query.is_pay);

    this.load_user();
  },

  methods: {
    load_order_info() {
      // 获取服务订单详情
      wx_get_goods_order_detail(this.orderId).then((res) => {
        budo_log.info("#219 wx_get_goods_order_detail", res, this.orderId);

        if (res.code === 0 && res.data) {
          res.data.extInfo = res.data.extInfo || "";

          this.orderDescription = res.data.userDescription;
          this.expressFee = res.data.expressFee;
          let arr = res.data.extInfo.split(",");
          this.orderInfo = {
            ...res.data,
            isAddress: res.data.goodsType === GOODS_TYPE_GENERAL_GOODS,
          };

          if (this.orderInfo.expressInfo && this.orderInfo.expressInfo.img) {
            this.imgs = this.orderInfo.expressInfo.img.split(",");
          }

          if (this.orderInfo.orderType === ORDER_TYPE_HEALTH) {
            const info = JSON.parse(this.orderInfo.extInfo);
            this.orderInfo.extInfo = [
              { key: "预约机构", value: info.orgName },
              { key: "姓名", value: info.name },
              { key: "性别", value: info.sex == "1" ? "男" : "女" },
              { key: "出生日期", value: info.birthday },
              { key: "年龄", value: info.age },
              {
                key: "婚姻状态",
                value: info.marriageStatus == "1" ? "已婚" : "未婚",
              },
              { key: "身份证号", value: info.cardId },
              { key: "电话", value: info.phone },
              { key: "预约日期", value: info.medicalTime },
            ];
          } else if (this.orderInfo.orderType === ORDER_TYPE_TRAVEL) {
            const info = JSON.parse(this.orderInfo.extInfo);
            this.orderInfo.extInfo = [
              { key: "联系人", value: info.name },
              { key: "联系电话", value: info.mobile },
              { key: "出行日期", value: info.resList[0].UseDate },
            ];

            info.passengerInfoList.map((p, index) => {
              this.orderInfo.extInfo.push({
                key: "游客" + (index + 1) + "_姓名",
                value: p.Cname,
              });
              this.orderInfo.extInfo.push({
                key: "游客" + (index + 1) + "_电话",
                value: p.ContactInfo,
              });
              this.orderInfo.extInfo.push({
                key: "游客" + (index + 1) + "_身份证",
                value: p.IdCardNo,
              });
            });
          } else {
            if (arr != null && arr.length > 0) {
              this.orderInfo.extInfo = arr.map((item) => {
                let temp = item.split(":");
                let key = temp[0];
                temp.shift();
                let value = temp.join(":");
                return {
                  key,
                  value,
                };
              });
            }
          }
        }

        budo_log.info(
          "#328 wx_get_goods_order_detail, orderInfo",
          this.orderInfo
        );
        this.payEnabled =
          res?.data?.statusOrder === 0 && res?.data?.statusPay === 0;
      });
    },

    load_user() {
      mall_wx_get_user_info().then((res) => {
        this.wxUser = res.data || {};
      });
    },

    cancelOrder(orderId) {
      Dialog.confirm({
        message: `申请后,后台客服会进行确认,是否提交?`,
      }).then(() => {
        wx_cancel_order(orderId).then((res) => {
          if (res.code === 0 && res.data === true) {
            Toast("取消订单成功");
          } else {
            Toast("取消订单失败: " + res.msg);
          }

          // 取消后 重新加载一下订单状态 重新渲染
          this.load_order_info();
        });
      });
    },

    go_kefu() {
      location.href = $wx_kefu_rc();
    },

    showCardInfo(orderId) {
      budo_log.info("#341 order-submit-detail showCardInfo, orderId=", orderId);

      this.$refs.OrderCodeDialog.showCardInfo(orderId);
    },

    showHowToUse(goodsId) {
      budo_log.info("#341 order-submit-detail showHowToUse, goodsId=", goodsId);

      this.$refs.HowToUseDialog.showHowToUse(goodsId);
    },

    onLogistcsImg(img) {
      ImagePreview([img]);
    },

    passwordInput(value) {
      this.payPassword += value;
      if (this.payPassword.length === 6) {
        this.paySetup();
      }
    },

    paySetup() {
      budo_log.info("#358 paySetup");

      request.post("/v5/provider-current").then((res) => {
        if ("API_xizang" === res?.data?.payMode) {
          this.go_pay_API_xizang();
          return;
        }

        this.paySetup_RC();
      });
    },

    go_pay_API_xizang() {
      location.href = "/v4/api-pay?orderId=" + this.orderId;
    },

    paySetup_RC() {
      budo_log.info("#368 paySetup_RC");

      let orderListUrl = {};

      if (!this.payPassword || this.payPassword.length !== 6) {
        this.showInputPassword = true;
        return;
      }

      /**
       * 还没获取orderType
       */
      switch (this.orderInfo.goodsType) {
        case GOODS_CATE_INFO.movie.id:
          orderListUrl = { path: "order-list", query: { orderType: "movie" } };
          break;
        case GOODS_CATE_INFO.ticket:
          orderListUrl = { path: "order-list", query: { orderType: "ticket" } };
          break;
        default:
          orderListUrl = { path: "order-list" };
      }

      budo_log.info("#398 mall_orders_repay");

      mall_orders_repay(this.orderId, this.payPassword).then((res) => {
        if (res.code !== 0) {
          this.payPassword = "";
          Dialog({ message: "支付失败:" + res.msg });
        } else {
          if (res.data) {
            const param = { data: res.data.payData };
            param.data.sign = res.data.payData.paySign;
            wx_sdk_wx_pay(
              param,
              () => {
                Toast({ message: "支付成功", duration: 1000 });
                setTimeout(() => {
                  this.$router.push(orderListUrl);
                }, 1000);
              },
              () => {
                this.$router.push(orderListUrl);
              }
            );
          } else {
            Toast({ message: "支付成功", duration: 1000 });
            setTimeout(() => {
              this.$router.push(orderListUrl);
            }, 1000);
          }
        }
      });
    },

    goAddress() {
      this.$router.push("/user-center-address");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";

.info {
  margin: 10px 5px 5px 5px;
  padding: 5px 10px;
  font-size: 15px;
  color: #6a6a6a;
  background: #fff;
  overflow: hidden;
  box-shadow: 1px 1px 5px 5px #0000001a;
  border-radius: 5px;
}

.identity-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 -10px;
  padding: 10px;
}
</style>
